module.exports = __webpack_public_path__ + "media/images/gallery/oc_off-263738015aee79f4e6959f72a7e57420.gif";